import { ClientInferRequest } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { SimilarPartFeedbackDto } from "#modules/feedback/infra/fetchSimilarPartFeedbacks.api";
import { ApiError } from "#shared/infra/apiError";

export type CreateSimilarPartFeedbackDto = ClientInferRequest<
  typeof contract.feedback.createSimilarPartFeedback
>["body"];

export const createSimilarPartFeedback = async (
  payload: CreateSimilarPartFeedbackDto,
): Promise<SimilarPartFeedbackDto> => {
  const response = await api.feedback.createSimilarPartFeedback.mutation({ body: payload });

  if (response.status === 201) {
    return response.body;
  }

  throw new ApiError("Failed to create SimilarPartFeedback", response.status, response.body);
};
